<template>
	<div class="t-page_faq t-work-area">
		<h1>{{ pageText.title }}</h1>
		<div class="t-work-area__row">
			<div class="t-work-area__column_small" v-if="!mobileState">
				<div class="t-work-area__cell t-faqMenu" v-stick-in-parent="stikyKit" id="faqMenu">
					<div class="t-faqMenu__item" v-for="(item, index) in faq" :key="index">
						<router-link :to="{name: 'faq', query: {question: 'faq_' + item.id}}"
												 class="t-faqMenu__link t-faqMenu__link_big"
												 :class="{'_active': 'faq_' + item.id === faq_active}"
												 :data-id="'faq_' + item.id">{{ item.title }}</router-link>
						<div>
							<router-link v-for="(child, index_child) in item.child"
													 :key="index_child"
													 :to="{name: 'faq', query: {question: 'faq_child_' + child.id}}"
													 class="t-faqMenu__link"
													 :class="{'_active': 'faq_child_' + child.id === faq_active}"
													 :data-id="'faq_child_' + child.id">{{ child.title }}</router-link>
						</div>
					</div>
					<span class="t-faqMenu__active" :style="{top: top + 'px'}"></span>
				</div>
			</div>
			<div class="t-work-area__column_big">
				<div class="t-work-area__cell t-faqBox js-box" :data-id="'faq_' + item.id" v-for="(item, index) in faq" :key="index">
					<h2>{{ item.title }}</h2>
					<div class="t-faqBox__item js-box" :data-id="'faq_child_' + child.id"  v-for="(child, index_child) in item.child" :key="index_child">
						<h3 @click.prevent="Open(index + '_' + index_child)" :class="{_open: open === index + '_' + index_child}">{{ child.title }}</h3>
						<div v-html="child.text" class="t-default" v-if="!mobileState || open === index + '_' + index_child"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/faqPage.json' : 'staticText',
        main: {
            title: "Частые вопросы"
        }
    };
	import {store} from '../../store'

  import {mapGetters} from 'vuex';
  import {mapActions} from 'vuex';

	export default {
	    data(){
	        return{
              pageText: {},

              stikyKit: {
                  options: {
                      offset_top: 114
                  }
              },
							open: -1
					}
			},
			computed: {
					...mapGetters('faq', ['faq', 'faq_active', 'top']),
					...mapGetters(['mobileState'])
			},
			methods: {
          ...mapActions(['UpdatePreloadState']),
					...mapActions('faq', ['scrollTo']),
          Open(i){
					    if(this.mobileState){
                  this.open = (this.open === i) ? -1 : i
							}
					},
          Load(pageText){
              this.pageText = pageText;
              setTimeout(() => {
                  this.UpdatePreloadState(false);
              }, 500)
          }
			},
      beforeRouteLeave (to, from, next) {
          this.UpdatePreloadState(true);
          next();
      },
			beforeRouteUpdate(to, from, next) {
	        this.scrollTo(to.query.question);
	      	next();
			},
      beforeRouteEnter (to, from, next) {
	        let active = Object.keys(to.query).length ? to.query.question : 0;

          let count = 0;
          let pageText = {};

          store.dispatch('staticText/LoadPageText', localeText).then((data) => {
              pageText = data;

              count++;
              RunNext();
          });
          store.dispatch('faq/LoadFaq', active).then(() => {
              count++;
              RunNext();
          });
          let RunNext = () => {
              if(count > 1)
                  next(vm => vm.Load(pageText))
          }
      }
	}
</script>

<style lang="sass">
@media(min-width: 770px)
	.t-faqMenu__link:hover
		color: $blue

.t-faqMenu
	list-style-type: none
	position: relative
	z-index: 2
	max-width: 320px
	&__active
		width: 0
		height: 0
		position: absolute
		left: 0
		border-top: 6px solid transparent
		border-bottom: 6px solid transparent
		border-left: 6px solid $blue
		margin-top: -6px
		transition: top .2s
	&__item
		margin-bottom: 32px
		&:last-child
			margin-bottom: 0
	&__link
		margin: 0 0 16px
		display: table
		transition: all .2s
		line-height: 1.2
		&._active
			color: $blue
		&:last-child
			margin-bottom: 0
		&_big
			font-weight: bold

.t-faqBox
	&:not(:last-child)
		margin-bottom: 24px
	h2
		margin-bottom: 26px
		font-size: 22px
	h3
		margin-bottom: 16px
	&__item
		margin: 0 -24px
		padding: 0 24px
		&:not(:last-child)
			padding-bottom: 32px
			margin-bottom: 32px
			border-bottom: 1px solid $border

@media(max-width: 769px)
	.t-faqBox__item
		margin: 0 -16px
		padding: 0 16px
		&:not(:last-child)
			padding-bottom: 26px
			margin-bottom: 26px
		&:last-child
			padding-bottom: 16px
		h3
			margin: 0
			position: relative
			&:after
				content: ''
				position: absolute
				right: -8px
				top: 50%
				margin-top: -20px
				width: 40px
				height: 40px
				background: url('/img/select.png') no-repeat center
			&._open:after
				transform: scale(1, -1)
		.t-default
			margin-top: 16px
</style>


// WEBPACK FOOTER //
// src/vue_pages/Faq/Index.vue